import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader/loader.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../extensions/components/components.module';
import { StyleLoaderComponent } from './style-loader/style-loader.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { LayoutModule as KendoLayoutModule } from '@progress/kendo-angular-layout';
import { NotificationComponent } from './notification/notification.component';
import { PipeModule } from '../extensions/pipes/pipe.module';
import { BaseBadgeDirective } from '../extensions/directives/base-badge.directive';
import { CountBadgeDirective } from '../extensions/directives/count-badge.directive';
import { CookieModalComponent } from './cookie-modal/cookie-modal.component';
import { FormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
  declarations: [
    LoaderComponent,
    HeaderMenuComponent,
    StyleLoaderComponent,
    SidebarMenuComponent,
    NotificationComponent,
    BaseBadgeDirective,
    CountBadgeDirective,
    CookieModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    TranslateModule.forChild(),
    ComponentsModule,
    KendoLayoutModule,
    PipeModule,
    FormsModule,
    DropDownsModule,
  ],
  exports: [
    LoaderComponent,
    HeaderMenuComponent,
    StyleLoaderComponent,
    SidebarMenuComponent,
    NotificationComponent,
    CookieModalComponent,
  ],
})
export class LayoutModule {}
